<template>
  <div class="about">
    <div id="cContent">
      <div id="elInput">
        <el-input
          class="input-with-select"
          size="small"
          placeholder="输入关键字进行过滤"
          v-model="filterText"
          clearable>
          <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
        </el-input>
      </div>
      <el-tree
      v-loading="loading"
      element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
        :data="treeData"
        style="height:calc(100% - 42px)"
        :props="defaultProps"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        @node-click="treeNodeClick"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys"
        :show-checkbox="treeMsg.showCheckBox"
        :check-on-click-node="treeMsg.showCheckBox"
        :default-checked-keys="treeMsg.defaultCheckedKeys"
        :check-strictly="true"
        @check="getCheckedKeys"
        ref="tree">
      </el-tree>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        treeMsg: {
          title: '角色管理', // 标题
          refreshTreeFlag: false, // 刷新标志
          self: 1, // 是（1）否（0）包含自身
          async: 0, // 同步树（0）异步树（1）
          showCheckBox: false, // 是否显示多选框
          onlyLeaf: true, // 是否只需要叶子节点(有多选框时使用),
          defaultCheckedKeys: [] // 默认选中
        },
        filterText: '',
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        parentId: '-1',
        nodeId: '',
        formLabelWidth: '120px',
        chooseTreeNode: {},
        defaultExpandedKeys: [],
        loading: false,
      }
    },
    props: {
      parentMsg: {},
      filter:{
        type:Boolean
      }
    },
    watch: {
      parentMsg:{
        handler(newValue, oldValue) {
          if (newValue.title!==undefined){
            this.treeMsg = newValue
          }
          this.getTemplateTree(newValue)
        },
        immediate: true
      }
    },
    mounted: function () {
      this.getTemplateTree(false)
    },
    methods: {
      getTemplateTree (data) {
        // this.loading=true;
        this.$axios.get(this.$idmConfig.roles.rolesTreeUrl + '?parentId=' + this.$idmConfig.roles.parentId + '&self=' + this.treeMsg.self + '&async=' + this.treeMsg.async + '&t=' + new Date().getTime()).then(response => {
          if (response.data.length <= 0) {
            this.$emit('treeInfo', { 'listenParentId': '-1', 'listenParentName': '暂无' })
          } else {
            // 展开至第一级
            this.defaultExpandedKeys = [response.data[0].id]
            if (response.data[0].children !== null && response.data[0].children.length > 0) {
              // 展开至第二级
              for (var i = 0; i < response.data[0].children.length; i++) {
                this.defaultExpandedKeys.push(response.data[0].children[i].id)
              }
            }
            this.treeData = response.data
            if (!data.refreshTreeFlag) {
              // this.$emit('treeInfo', { 'listenParentId': response.data[0].id, 'listenParentName': response.data[0].label })
            }
            this.defaultExpandedKeys = [...new Set([...this.defaultExpandedKeys,...this.treeMsg.defaultCheckedKeys])];
            // 过滤显示选中节点
            if (this.filter) {
              this.$nextTick(() => {
                this.$refs.tree.filter(1)
              })
            }
          }
          // this.loading=false;
        }).catch(error => {
          // this.loading=false;
          console.log('error:' + error.toString())
        })
      },
      treeNodeClick (node) {
        this.chooseTreeNode = node
        this.$emit('treeInfo', { 'listenParentId': node.id, 'listenParentName': node.label })
      },
      treeFilter (){
        this.$refs.tree.filter(this.filterText)
      },
      filterNode (value, data, node) {
        if (this.filter && !this.filterText) {
          return node.checked || node.indeterminate
        } else  {
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        }
      },
      getCheckedKeys (data){
        if (this.filter) {
          this.$refs.tree.filter(1)
        }
        this.$refs.tree.getCheckedKeys(true)
        this.$emit('getCheckedKeys', this.$refs.tree.getCheckedKeys(this.treeMsg.onlyLeaf),this.filter)
      }
    }
  }
</script>

<style lang="less">
  .about {
    height: 100%;
    box-sizing: border-box;
    padding: 10px 0;
  }
  #cContent{
    height: 100%;
    padding: 0px;
    margin: 0px;
    .el-tree{
      height: calc(100% - 42px);
      overflow-y: auto;
    }
  }
  #elInput{
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RolesTree.vue